<template>
  <div
    :class="['right_content', tapIndex == 8 ? 'hidden' : '']"
    ref="rightDom"
    :style="`padding-top:${Top}px;`"
  >
    <slot></slot>
  </div>
</template>

<script setup>
import { isSwitch } from '@/util/config';
import { ref, toRefs, onMounted, nextTick, onBeforeUnmount } from 'vue';
import { useOverViewStore } from '@/store';
import { storeToRefs } from 'pinia';
const $store = useOverViewStore();
const { tapIndex } = storeToRefs($store);
import { clientWidth, clientHeight, isAdapt, isPeerStream, ueServer } from '@/util/config';
const props = defineProps({
  Top: {
    type: Number,
    default: 88,
  },
});

const { Top } = toRefs(props);

const rightDom = ref(null);
let rightWidthed = ref(null);
let timer = ref(null);
onMounted(() => {
  nextTick(() => {
    clearTimeout(timer.value);
    let rightWidth = rightDom.value.offsetWidth;
    rightWidthed.value = rightDom.value.offsetWidth;

    rightDom.value.style.left = `${clientWidth - rightWidth}px`;
    // 右边逻辑
    switch (isSwitch) {
      case false:
        rightDom.value.style.left = `${clientWidth - rightWidth}px`;
        timer.value = setTimeout(() => {
          rightDom.value.style.transition = `left 0s`;
        }, 100);
        break;
      case true:
        rightDom.value.style.left = `${clientWidth + 20}px`;
        timer.value = setTimeout(() => {
          rightDom.value.style.transition = `left 0.8s`;
          rightDom.value.style.left = `${clientWidth - rightWidth}px`;
        }, 300);
        break;
    }
  });
});
onBeforeUnmount(() => {
  clearTimeout(timer.value);
});
</script>

<style lang="scss" scoped>
.right_content {
  position: absolute;
  // left: 1940px;
  top: 0px;
  height: 1920px;
  padding-right: 9px;
  box-sizing: border-box;
  transition: all 0.8s;
  &.hidden {
    left: 2410px !important;
  }
}
</style>
